import React from 'react'
import './estilos.css';
import ListaDePreciosEspecial from '../../Componentes/ListaDePreciosEspecial';

function ListaDePreciosEspecialPage() {
  return (
    <div className='cont-page-ofertas'>
      <ListaDePreciosEspecial/>
    </div>
  )
}

export default ListaDePreciosEspecialPage